import { ChainID, ChainPath } from '@ankr.com/chains-list';

export const mapSharkChainToChainPath = (chainPath: ChainPath) => {
  switch (chainPath) {
    case 'aapi_v2':
      return ChainID.MULTICHAIN as ChainPath;
    default:
      return chainPath;
  }
};
